import { formatCurrency } from "@/common/utils/formatters";

interface ResumeItemProps {
  label: string;
  value: string | number;
  textClassName?: string;
  isCurrencyValue?: boolean
}

const ResumeItem = ({
  label,
  value,
  textClassName = "",
  isCurrencyValue = true
}: ResumeItemProps) => {
  return (
    <div>
      <p className={`font-light italic text-[14px] ${textClassName}`}>{label}</p>
      <p className={`text-[18px] ${textClassName}`}>
        {isCurrencyValue ? formatCurrency(Number(value) || 0) : Number(value)}
      </p>
    </div>
  )
}

export default ResumeItem